import { injectable } from "inversify";
import { ApiPage } from "@/core/models/page.model";
import { TableRepo } from "../table.repo";
import { AppUserModel } from "@/core/models/app-user.model";
import { AppRoleModel } from "@/core/models/app-role.model";

interface _AppUserGetParams {
    search?: string;
}

@injectable()
export class AppUserRepo extends TableRepo<AppUserModel> {
    constructor() {
        super("/api/AppUser");
    }

    async getData(index: number, params: _AppUserGetParams, pageSize = 10): Promise<ApiPage<AppUserModel>|null> {
        return await super.getData(index, params, pageSize);
    }

    async create(model: AppUserModel) {
        return super.create(model, "add");
    }
    
    async getRoles(id: string) {
        const response = await this.apiRepo.get<AppRoleModel[]>(`${this.basepath}/get-role-by-user`, {id});
        if (response?.code === "00") {
            return response.result;
        }
        return [];
    }

    async changeRoles(userId: string, roles: AppRoleModel[]) {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/change-role`, {userId, roles});
            if (response?.code === '00') {
                this.changes.next(Date.now());
                return true
            };
            return false;
        } catch (err) {
            console.log(err);
        }
    }

    async changePassword(userName: string, newPassword: string ) {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/reset-password-by-admin`, {userName, newPassword});
            if (response?.code === '00') {
                this.changes.next(Date.now());
                return true
            };
            return false;
        } catch (err) {
            console.log(err);
        }
    }

    async changeMyPassword(id: string, oldPassword: string, newPassword: string) {
        try {
            const response = await this.apiRepo.post(`${this.basepath}/change-password`, {id, oldPassword, newPassword});
            if (response?.code === '00') {
                this.changes.next(Date.now());
                return true
            };
            return response?.code;
        } catch (err) {
            console.log(err);
        }
    }

    async generateUsernameByDepartmentId(departmentId: string) {
        try {
            const response = await this.apiRepo.get<string>(`${this.basepath}/get-new-username-by-departmentId`, {departmentId});
            if (response?.code === "00") {
                return response.result;
            }
            return null;
        } catch (err) {
            console.log(err);
            return null;
        }
    }
}